import { render, staticRenderFns } from "./PostcardsMaterialEdit.vue?vue&type=template&id=76c8b6ba&"
import script from "./PostcardsMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./PostcardsMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports